<template>
  <NotificationTypeWrapper :notification="notification">
    <p class="my-0">
      <strong v-text="memberNames" /> added to <b v-text="groupTitle" /> group
      <a
        :href="actionLink"
        v-text="'view group'"
      />
      .
    </p>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'MembersHaveBeenAddedToGroupNotification',
  mixins: [NotificationTypeMixin],
  computed: {
    memberNames() {
      return this.notification.attributes.data.members_names
    },
    groupTitle() {
      return this.notification.attributes.data.group_title
    },
    actionLink() {
      return this.$urlGenerator.active() + 'members/membership-groups/' + this.notification.attributes.data.group_uuid
    },
  },
}
</script>
